import { translate } from '../../../../common/intl';
import { KendoDataGridShellColumn } from '../../../components/KendoDataGrid/KendoDataGridShell';

interface ColumnDef {
  id: string
  title: string
  width?: number
  minWidth?: number
}

interface MaterialShellColumnOptions {
  isMPIProcedure?: boolean
  isLHRStep?: boolean
  isEBProcedure?: boolean
}

const MPI_COLUMNS: ColumnDef[] = [
  { id: 'title', title: 'form.builder.procedure.material.title', minWidth: 250 },
  { id: 'LHRTparameter', title: 'form.builder.procedure.lhrt.parameter.title', width: 150 },
  { id: 'quantity', title: 'form.builder.procedure.material.table.quantity.title', width: 150 },
  { id: 'unit', title: 'form.builder.procedure.material.table.unit.title', width: 150 },
];

const LHRT_COLUMNS: ColumnDef[] = [
  { id: 'title', title: 'form.builder.procedure.material.title' },
  { id: 'quantity', title: 'form.builder.procedure.material.table.quantity.title', width: 150 },
  { id: 'unit', title: 'form.builder.procedure.material.table.unit.title', width: 150 },
];

const EB_COLUMNS: ColumnDef[] = [
  { id: 'title', title: 'form.builder.procedure.material.table.material.title', minWidth: 250 },
  { id: 'lotId', title: 'form.builder.procedure.material.table.lot.number.title', width: 180 },
  { id: 'quantity', title: 'form.builder.procedure.material.table.quantity.title', width: 150 },
  { id: 'unit', title: 'form.builder.procedure.material.table.unit.title', width: 150 },
  { id: 'attachments', title: 'form.builder.procedure.material.table.attachments.title', width: 300 },
];

const DEFAULT_COLUMNS: ColumnDef[] = [
  { id: 'title', title: 'form.builder.procedure.material.table.material.title' },
  { id: 'lotId', title: 'form.builder.procedure.material.table.lot.number.title' },
  { id: 'quantity', title: 'form.builder.procedure.material.table.quantity.title', width: 150 },
  { id: 'unit', title: 'form.builder.procedure.material.table.unit.title', width: 150 },
  { id: 'expiryDate', title: 'form.builder.procedure.material.table.expiry.date.title', width: 150 },
];

const toShellColumns = (columns: ColumnDef[]): KendoDataGridShellColumn[] =>
  columns.map((column) => ({
    id: column.id,
    title: translate(column.title),
    width: column.width,
    minWidth: column.minWidth,
  }));

export const getMaterialShellColumns = ({
  isMPIProcedure,
  isLHRStep,
  isEBProcedure,
}: MaterialShellColumnOptions): KendoDataGridShellColumn[] => {
  if (isMPIProcedure && !isLHRStep) {
    return toShellColumns(MPI_COLUMNS);
  }
  if (isLHRStep) {
    return toShellColumns(LHRT_COLUMNS);
  }
  if (isEBProcedure) {
    return toShellColumns(EB_COLUMNS);
  }
  return toShellColumns(DEFAULT_COLUMNS);
};
